import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { workAdvisoryKeys } from "@/lib/query-keys";
import type { CompanyDocument } from "@/types/workadvisory";

/** Los documentos que la empresa nos entregó. Solo admin. */
export function useCompanyDocuments(organizationId?: string) {
  return useQuery({
    queryKey: workAdvisoryKeys.companyDocuments(organizationId),
    enabled: Boolean(organizationId),
    queryFn: async () => {
      const res = await fetchToBackend<{ data: CompanyDocument[] }>(
        `/admin/company-documents/${organizationId}`,
      );
      return res.data;
    },
  });
}
